import { playUiClickB } from '../../assets/preloadSounds';
import {
  closeInfoPopup,
  toggleInfoPopup,
} from '../shared/infoPopup/infoPopupControllerActions';
import type { TicketsScreenModel } from './TicketsScreenModelScreen';

export class TicketsScreenController {
  constructor(private readonly model: TicketsScreenModel) {}

  handleInfoButtonClick = () => {
    toggleInfoPopup(this.model);
  };

  handleInfoClose = () => {
    closeInfoPopup(this.model);
  };

  handleOpenTasks = () => {
    playUiClickB();
    this.model.onOpenTasks?.();
  };

  handleGoBack = () => {
    this.model.onGoBack?.();
  };
}
